/** FP Uline buy UI — qty snap + soft-launch ATC block when ≤ $0.01 / call-for-price */
(function () {
  function money(cents) { return '$' + (cents / 100).toFixed(2); }
  function snap(n, min, step) {
    n = parseInt(n, 10);
    if (isNaN(n) || n < min) return min;
    if (step > 1) {
      var off = (n - min) % step;
      if (off !== 0) n = n - off;
      if (n < min) n = min;
    }
    return n;
  }

  function isCallForPrice() {
    if (document.documentElement.classList.contains('fp-call-for-price-mode')) return true;
    var dual = document.querySelector('[data-fp-dual-price]');
    if (dual && dual.getAttribute('data-fp-call-for-price') === 'true') return true;
    if (dual && dual.querySelector('.fp-call-price')) return true;
    var sticky = document.querySelector('[data-fp-sticky-atc]');
    if (sticky && sticky.getAttribute('data-fp-call-for-price') === 'true') return true;
    var cents = dual ? parseInt(dual.getAttribute('data-unit-price-cents') || '0', 10) : NaN;
    if (!isNaN(cents) && cents > 0 && cents <= 1) return true;
    return false;
  }

  function ensureQuoteSlot() {
    var existing = document.querySelector('[data-fp-main-quote-only]');
    if (existing) return existing;
    var row =
      document.querySelector('.product-form-buttons') ||
      document.querySelector('[ref="productFormButtons"]') ||
      document.querySelector('.buy-buttons-block') ||
      document.querySelector('product-form-component');
    if (!row) return null;
    var slot = document.createElement('div');
    slot.className = 'fp-main-quote-only';
    slot.setAttribute('data-fp-main-quote-only', '');
    slot.innerHTML =
      '<a class="fp-main-quote-only__quote" href="/pages/request-a-quote">Request a Quote</a>' +
      '<a class="fp-main-quote-only__phone" href="tel:7867101666">Call (786) 710-1666</a>';
    row.parentNode.insertBefore(slot, row.nextSibling);
    return slot;
  }

  function blockAtc() {
    if (!isCallForPrice()) return false;
    document.documentElement.classList.add('fp-call-for-price-mode');
    ensureQuoteSlot();

    var forms = document.querySelectorAll('form[action*="/cart/add"], product-form-component form');
    forms.forEach(function (form) {
      if (form.getAttribute('data-fp-cfp-bound') === '1') return;
      form.setAttribute('data-fp-cfp-bound', '1');
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }, true);
    });

    document.querySelectorAll(
      'button.add-to-cart-button, button[name="add"], .add-to-cart-button, [data-fp-sticky-atc-btn], .shopify-payment-button button'
    ).forEach(function (btn) {
      btn.disabled = true;
      btn.setAttribute('aria-disabled', 'true');
      btn.setAttribute('tabindex', '-1');
      if (btn.getAttribute('data-fp-cfp-click') === '1') return;
      btn.setAttribute('data-fp-cfp-click', '1');
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }, true);
    });
    return true;
  }

  function setupQty() {
    var dual = document.querySelector('[data-fp-dual-price][data-sell-by="unit"]');
    var sub = document.querySelector('[data-fp-subtotal]');
    var input = document.querySelector('quantity-selector-component input[name="quantity"], .quantity-selector input[name="quantity"], form[action*="/cart/add"] input[name="quantity"]');
    if (!input) return;
    var caseQty = parseInt((dual && dual.getAttribute('data-case-qty')) || (sub && sub.getAttribute('data-case-qty')) || input.getAttribute('data-min') || '1', 10) || 1;
    var unitCents = parseInt((dual && dual.getAttribute('data-unit-price-cents')) || (sub && sub.getAttribute('data-unit-price-cents')) || '0', 10) || 0;
    var sellBy = dual ? dual.getAttribute('data-sell-by') : (sub ? 'unit' : 'case');
    if (sellBy !== 'unit') return;
    input.min = String(caseQty);
    input.step = String(caseQty);
    input.setAttribute('data-min', String(caseQty));
    if (!input.value || parseInt(input.value, 10) < caseQty) input.value = String(caseQty);
    function refresh() {
      var q = snap(input.value, caseQty, caseQty);
      if (String(q) !== String(input.value)) input.value = String(q);
      if (sub) {
        var amt = sub.querySelector('[data-fp-subtotal-amt]');
        if (amt && unitCents) amt.textContent = money(unitCents * q);
      }
      var stickyAmt = document.querySelector('[data-fp-sticky-sub-amt]');
      if (stickyAmt && unitCents) stickyAmt.textContent = money(unitCents * q);
    }
    input.addEventListener('change', refresh);
    input.addEventListener('input', refresh);
    input.addEventListener('blur', refresh);
    document.addEventListener('click', function (e) {
      if (e.target && (e.target.closest('.quantity-plus') || e.target.closest('.quantity-minus') || e.target.closest('[data-fp-sticky-qty-inc]') || e.target.closest('[data-fp-sticky-qty-dec]'))) {
        setTimeout(refresh, 30);
      }
    });
    refresh();
  }

  function setup() {
    blockAtc();
    if (!isCallForPrice()) setupQty();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();
  document.addEventListener('shopify:section:load', setup);
  // Re-assert block after theme hydration
  setTimeout(blockAtc, 200);
  setTimeout(blockAtc, 1000);
})();
